import { ChevronDown, ExternalLink } from 'lucide-react';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { FC, ReactNode, useRef } from 'react';

interface Props {
  data: {
    title: string;
    subtitle: string;
    linkName: string[];
    link: string[];
    icon: ReactNode;
    overlayPanel?: boolean;
  };
}

const StudentLearnOtherResourcesCard: FC<Props> = ({ data }) => {
  const opRef = useRef<OverlayPanel | null>(null);
  return (
    <>
      <OverlayPanel ref={opRef}>
        {/* <div className="tw-bg-white tw-p-4 tw-border-1 tw-rounded-xl tw-w-[12rem] tw-max-h-[45vh] tw-overflow-scroll"> */}
        <Button
          label={data.linkName[1]}
          link
          className="tw-flex tw-flex-row-reverse !tw-text-sm tw-mt-auto tw-ml-auto tw-gap-x-2"
          icon={<ExternalLink size={16} />}
          onClick={() => window.open(`${data.link[1]}`)}
        />
        <Button
          label={data.linkName[2]}
          link
          className="tw-flex tw-flex-row-reverse !tw-text-sm tw-mt-auto tw-ml-auto tw-gap-x-2"
          icon={<ExternalLink size={16} />}
          onClick={() => window.open(`${data.link[2]}`)}
        />
        {/* </div> */}
      </OverlayPanel>
      <div className="nc_student-learn-other-resources-card">
        <span className="nc_student-learn-other-resources-card-icon">{data.icon}</span>
        <div className="tw-flex tw-flex-col">
          <h1 className="tw-text-base tw-font-bold tw-font-atkinson tw-text-neutral-950">{data.title}</h1>
          <p className="tw-m-0 tw-text-base tw-font-atkinson tw-text-neutral-700">{data.subtitle}</p>
          <Button
            label={data.linkName[0]}
            link
            className="tw-flex tw-flex-row-reverse !tw-text-sm tw-mt-auto tw-ml-auto tw-gap-x-2"
            icon={data.overlayPanel ? <ChevronDown size={16} /> : <ExternalLink size={16} />}
            onClick={e => {
              data.overlayPanel ? opRef.current?.toggle?.(e) : window.open(`${data.link[0]}`);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default StudentLearnOtherResourcesCard;
